import PropTypes from "prop-types";
import { Grid2, Typography } from "@mui/material";
import { ArrowBack, Refresh } from "@mui/icons-material";
import { Image } from "mui-image";

import logo from "../assets/logo.png";

import { PrimaryBorderButton } from "./Buttons.js";

const ErrorFallback = ({ message = "Something went wrong! Please try again!", refetch = () => window.location.reload() }) => (
	<Grid2
		container
		direction="column"
		alignItems="center"
		sx={{
			position: "absolute",
			top: "50%",
			left: "50%",
			transform: "translate(-50%, -50%)",
		}}
	>
		<Grid2 size={{ xs: 12 }} sx={{ display: "flex", justifyContent: "center" }}>
			<Image src={logo} alt="TCTT Logo" width="250px" />
		</Grid2>
		<Grid2 size={{ xs: 12 }} mt={2}>
			<Grid2 container direction="column" spacing={6}>
				<Grid2 size={{ xs: 12 }}>
					<Typography align="center" variant="h6">{message}</Typography>
				</Grid2>
				<Grid2 size={{ xs: 12 }}>
					<Grid2 container spacing={2} justifyContent="center">
						<Grid2>
							<PrimaryBorderButton
								title={"Go Back"}
								startIcon={<ArrowBack />}
								onClick={() => { window.location.href = "/"; }}
							/>
						</Grid2>
						{refetch && (
							<Grid2>
								<PrimaryBorderButton
									title={"Try Again"}
									startIcon={<Refresh />}
									onClick={refetch}
								/>
							</Grid2>
						)}
					</Grid2>
				</Grid2>
			</Grid2>
		</Grid2>
	</Grid2>
);

ErrorFallback.propTypes = { message: PropTypes.string, refetch: PropTypes.func };

export default ErrorFallback;
